import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { DriversGroupItem } from '../../app/portal/pages/drivers/drivers.types';

export const driversGroupsAdapter = createEntityAdapter<DriversGroupItem>({
  selectId: (item) => item.id as number,
});

export interface DriversGroupsState extends EntityState<DriversGroupItem> {
  loading: boolean;
  error?: string;
}

export const initialDriversGroupsState: DriversGroupsState = driversGroupsAdapter.getInitialState({
  loading: false,
  error: undefined,
});
